import { sqliteTable, text, integer, index, type AnySQLiteColumn } from "drizzle-orm/sqlite-core";

// ============================================================================
// accounts — ผังบัญชี (Chart of Accounts) — tree structure
// ============================================================================
export const accounts = sqliteTable("accounting_accounts", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  accountNumber: text("account_number").notNull(),
  accountName: text("account_name").notNull(),
  accountNameEn: text("account_name_en"),
  accountType: text("account_type", {
    enum: ["asset", "liability", "income", "expense", "equity"],
  }).notNull(),
  parentId: text("parent_id").references((): AnySQLiteColumn => accounts.id), // self-ref tree → accounts.id
  isGroup: integer("is_group").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  sourceModule: text("source_module"), // which module seeded this account (null = user-created)
  balanceDirection: text("balance_direction", {
    enum: ["debit", "credit"],
  }).notNull(),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyTypeIdx: index("acc_company_type_idx").on(table.companyId, table.accountType, table.isGroup),
  companyNumberIdx: index("acc_company_number_idx").on(table.companyId, table.accountNumber),
}));

// Type exports
export type Account = typeof accounts.$inferSelect;
export type NewAccount = typeof accounts.$inferInsert;
